export const passwordPattern = /^.{8,16}$/;
